import React from 'react';
import { CheckCircle, Clock, Package } from 'lucide-react';

const STATUS_BADGES = {
  in_que: {
    label: 'In Dispatch Que',
    icon: Clock,
    colors: {
      backgroundColor: '#eef2ff',
      color: '#4338ca',
      borderColor: '#c7d2fe'
    }
  },
  moc_in_progress: {
    label: 'MOC In Progress',
    icon: Package,
    colors: {
      backgroundColor: '#eef2ff',
      color: '#4338ca',
      borderColor: '#c7d2fe'
    }
  },
  moc_draft: {
    label: 'MOC Draft',
    icon: Package,
    colors: {
      backgroundColor: '#eef2ff',
      color: '#4338ca',
      borderColor: '#c7d2fe'
    }
  },
  pending_ops_approval: {
    label: 'Waiting Ops Approval',
    icon: Clock,
    colors: {
      backgroundColor: '#fffbeb',
      color: '#b45309',
      borderColor: '#fcd34d'
    }
  },
  pending_finance: {
    label: 'Waiting for Finance',
    icon: Clock,
    colors: {
      backgroundColor: '#ecfeff',
      color: '#155e75',
      borderColor: '#a5f3fc'
    }
  },
  moc_pending_finance: {
    label: 'Waiting for Finance',
    icon: Clock,
    colors: {
      backgroundColor: '#ecfeff',
      color: '#155e75',
      borderColor: '#a5f3fc'
    }
  },
  moc_approved: {
    label: 'MOC Approved',
    icon: CheckCircle,
    colors: {
      backgroundColor: '#ecfdf5',
      color: '#047857',
      borderColor: '#86efac'
    }
  },
  packing_queued: {
    label: 'Packing Queued',
    icon: Clock,
    colors: {
      backgroundColor: '#f8fafc',
      color: '#475569',
      borderColor: '#cbd5e1'
    }
  },
  packing_scheduled: {
    label: 'Packing Scheduled',
    icon: CheckCircle,
    colors: {
      backgroundColor: '#eff6ff',
      color: '#1d4ed8',
      borderColor: '#93c5fd'
    }
  },
  packed_ready: {
    label: 'DC Pending',
    icon: CheckCircle,
    colors: {
      backgroundColor: '#ecfdf5',
      color: '#047857',
      borderColor: '#86efac'
    }
  },
  invoice_pending: {
    label: 'Invoice Pending',
    icon: Clock,
    colors: {
      backgroundColor: '#fef2f2',
      color: '#dc2626',
      borderColor: '#fecaca'
    }
  },
  ewaybill_pending: {
    label: 'E-way Bill Pending',
    icon: Clock,
    colors: {
      backgroundColor: '#fffbeb',
      color: '#d97706',
      borderColor: '#fde68a'
    }
  },
  ewaybill_complete: {
    label: 'QC Pending',
    icon: CheckCircle,
    colors: {
      backgroundColor: '#ecfdf5',
      color: '#047857',
      borderColor: '#86efac'
    }
  },
  invoice_ready: {
    label: 'Invoice Ready',
    icon: CheckCircle,
    colors: {
      backgroundColor: '#ecfdf5',
      color: '#047857',
      borderColor: '#86efac'
    }
  },
  dispatched: {
    label: 'In Transit',
    icon: Clock,
    colors: {
      backgroundColor: '#fff7ed',
      color: '#c2410c',
      borderColor: '#fdba74'
    }
  },
  in_transit: {
    label: 'In Transit',
    icon: Clock,
    colors: {
      backgroundColor: '#fff7ed',
      color: '#c2410c',
      borderColor: '#fdba74'
    }
  },
  delivered: {
    label: 'Delivered',
    icon: CheckCircle,
    colors: {
      backgroundColor: '#ecfdf5',
      color: '#047857',
      borderColor: '#86efac'
    }
  }
};

const baseBadgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '4px 10px',
  borderRadius: '999px',
  border: '1px solid',
  fontSize: '12px',
  fontWeight: '700',
  lineHeight: 1,
  whiteSpace: 'nowrap'
};

export const getStatusBadgeMeta = (status) => STATUS_BADGES[status] || null;
export const getOrderStatusBadgeMeta = getStatusBadgeMeta;
export const getDispatchStatusBadgeMeta = getStatusBadgeMeta;

const StatusBadge = ({ status, meta, iconSize = 14 }) => {
  const resolvedMeta = meta || getStatusBadgeMeta(status);

  if (!resolvedMeta) return null;

  const Icon = resolvedMeta.icon;

  return (
    <span
      style={{
        ...baseBadgeStyle,
        backgroundColor: resolvedMeta.colors.backgroundColor,
        color: resolvedMeta.colors.color,
        borderColor: resolvedMeta.colors.borderColor
      }}
    >
      {Icon ? <Icon size={iconSize} /> : null}
      {resolvedMeta.label}
    </span>
  );
};

export default StatusBadge;
